import { useEffect, useState } from "react"
import axios from "axios"

const useNexmartRetailers = (sku) => {
  const [retailers, setRetailers] = useState(null)
  const [hasRetailers, setHasRetailers] = useState(undefined)
  const [nexmartNotConfigured, setNexmartNotConfigured] = useState(undefined)
  useEffect(() => {
    if (
      process.env.NEXMART_SUPPLIER &&
      process.env.NEXMART_API_URL &&
      process.env.NEXMART_USERNAME &&
      process.env.NEXMART_PASSWORD
    ) {
      setNexmartNotConfigured(false)
      axios
        .get(process.env.NEXMART_API_URL, {
          auth: {
            username: process.env.NEXMART_USERNAME,
            password: process.env.NEXMART_PASSWORD,
          },
          params: {
            services: "online",
            supplier: process.env.NEXMART_SUPPLIER,
            "pid[1]": sku,
          },
        })
        .then((res) => {
          setRetailers(res.data.retailers)
          if (res.data.retailers && res.data.retailers.length > 0) {
            setHasRetailers(true)
          } else {
            setHasRetailers(false)
          }
        })
    } else {
      setNexmartNotConfigured(true)
      setRetailers([])
    }

    return () => {
      setRetailers(null)
    }
  }, [sku])
  return [hasRetailers, retailers, nexmartNotConfigured]
}

export default useNexmartRetailers
